import React from 'react';
import ReactSelect from 'react-select';
import { selectStyles } from './selectStyles';

export const Select = ({ options, onChange, styles, ...props }) => (
  <ReactSelect
    options={options}
    onChange={onChange}
    menuPortalTarget={document.body}
    menuPosition="fixed"
    styles={{ ...selectStyles, ...styles }}
    {...props}
  />
);

export default Select;
